// Qué tipo de dispositivo está usando el sistema.

/**
 * ¿Es un celular o una tablet? Ahí tiene sentido sacar una foto al toque (patente,
 * km del tablero). En la computadora no: se escribe (Rodrigo, 16/10/2026), aunque
 * tenga cámara web o pantalla táctil.
 */
export const esCelularOTablet = (): boolean => {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  if (/android|iphone|ipad|ipod|mobile/i.test(ua)) return true;
  // iPadOS se presenta como Mac de escritorio
  if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) return true;
  // Tablets que no dicen "mobile": el dedo es el puntero principal. Una notebook
  // con pantalla táctil sigue teniendo el mouse/touchpad como principal.
  return typeof window.matchMedia === 'function' && window.matchMedia('(pointer: coarse)').matches;
};
